module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('div', {
    staticClass: "box box-primary center-block"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart font-dark"
  }), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Relatórios - Questionários")])]), _vm._v(" "), (!_vm.isRenderingReports) ? _c('section', {
    staticClass: "content"
  }, [_c('button', {
    staticClass: "btn btn-primary top-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.renderReports()
      }
    }
  }, [_vm._v("Gerar")]), _vm._v(" "), _c('div', {
    staticClass: "row main-row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-9"
  }, [_c('div', {
    staticClass: "report-row"
  }, [_c('h4', [_vm._v("\n              Eixo do Questionário\n              "), _c('button', {
    staticClass: "btn btn-default btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.selectAll(_vm.axes)
      }
    }
  }, [_vm._v("Selecionar todos")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clearSelected(_vm.axes)
      }
    }
  }, [_vm._v("Limpar")])]), _vm._v(" "), _c('div', {
    staticClass: "axes-container"
  }, _vm._l((_vm.axes), function(axis) {
    return _c('span', {
      class: {
        highlight: axis.isSelected
      },
      on: {
        "click": function($event) {
          axis.isSelected = !axis.isSelected
        }
      }
    }, [_vm._v("\n                " + _vm._s(axis.description) + "\n              ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('div', {
    staticClass: "report-row"
  }, [_c('p', [_c('strong', [_vm._v("Ano")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "center-inside-col"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.year),
      expression: "year"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.year = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.getAvailableYears), function(year) {
    return _c('option', {
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year))])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row main-row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [((_vm.availableReports.length > 0 || _vm.respondents.length > 0) && (_vm.userHasAdminRole || _vm.userHasPartnerRole)) ? _c('div', {
    staticClass: "report-row"
  }, [_c('h4', [_vm._v("\n              Respondentes\n              "), _c('button', {
    staticClass: "btn btn-default btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.selectAll(_vm.respondents)
      }
    }
  }, [_vm._v("Selecionar todos")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clearSelected(_vm.respondents)
      }
    }
  }, [_vm._v("Limpar")])]), _vm._v(" "), _vm._l((_vm.respondents), function(park) {
    return _c('div', {
      key: park.id,
      staticClass: "checkbox"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (park.isSelected),
        expression: "park.isSelected"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(park.isSelected) ? _vm._i(park.isSelected, null) > -1 : (park.isSelected)
      },
      on: {
        "change": function($event) {
          var $$a = park.isSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(park, "isSelected", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(park, "isSelected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(park, "isSelected", $$c)
          }
        }
      }
    }), _vm._v(" " + _vm._s(park.name) + "\n              ")])])
  })], 2) : _vm._e(), _vm._v(" "), ((_vm.availableReports.length > 0 || _vm.respondents.length > 0) && _vm.userHasParkRole) ? _c('div', {
    staticClass: "report-row"
  }, [_c('h4', [_vm._v("\n              Respondentes\n              "), _c('button', {
    staticClass: "btn btn-default btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.selectAll(_vm.respondents)
      }
    }
  }, [_vm._v("Todos os Parques")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.selectCurrentAuthenticatedParkAsRespondent()
      }
    }
  }, [_vm._v("Apenas eu")])]), _vm._v(" "), (_vm.isAllRespondentsSelected) ? _c('p', [_vm._v("Você visualizará relatórios referentes às respostas de todos os Parques Tecnológicos cadastrados na plataforma que responderam o questionário no ano selecionado.")]) : _vm._e(), _vm._v(" "), (!_vm.isAllRespondentsSelected && _vm.isCurrentAuthenticatedParkSelected) ? _c('p', [_vm._v("Você visualizará relatórios referentes às respostas do seu questionário no ano selecionado.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-8"
  }, [((_vm.availableReports.length > 0 || _vm.respondents.length > 0)) ? _c('div', {
    staticClass: "report-row"
  }, [_c('h4', [_vm._v("\n              Relatórios\n              "), _c('button', {
    staticClass: "btn btn-default btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.selectAll(_vm.availableReports)
      }
    }
  }, [_vm._v("Selecionar todos")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clearSelected(_vm.availableReports)
      }
    }
  }, [_vm._v("Limpar")])]), _vm._v(" "), _vm._l((_vm.availableReports), function(report) {
    return _c('div', {
      key: report.id,
      staticClass: "checkbox"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (report.isSelected),
        expression: "report.isSelected"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(report.isSelected) ? _vm._i(report.isSelected, null) > -1 : (report.isSelected)
      },
      on: {
        "change": function($event) {
          var $$a = report.isSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(report, "isSelected", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(report, "isSelected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(report, "isSelected", $$c)
          }
        }
      }
    }), _vm._v(" " + _vm._s(report.title) + "\n              ")])])
  })], 2) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.isRenderingReports) ? _c('section', {
    staticClass: "content"
  }, [_c('button', {
    staticClass: "btn btn-primary top-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isRenderingReports = false
      }
    }
  }, [_vm._v("Voltar")]), _vm._v(" "), _c('div', {
    staticClass: "row text-center display-flex"
  }, _vm._l((_vm.selectedReports), function(report) {
    return _c('div', {
      key: report.id,
      staticClass: "col-xs-12 col-lg-6"
    }, [_c(_vm.getReportComponent(report), {
      tag: "component",
      attrs: {
        "data": report.data
      }
    })], 1)
  }), 0)]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1dfd1058","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/reports/QuizReports.vue
// module id = 637
// module chunks = 1